export default "__VITE_ASSET__DnL4btS9__"